export const ORDER_CREATED = 'CREATED';
export const ORDER_SAVED = 'SAVED';
export const ORDER_APPROVED = 'APPROVED';
export const ORDER_VOIDED = 'VOIDED';
export const ORDER_COMPLETED = 'COMPLETED';
export const ORDER_PAYER_ACTION_REQUIRED = 'PAYER_ACTION_REQUIRED';

export const ORDER_CAPTURE_COMPLETED = 'COMPLETED';
export const ORDER_CAPTURE_DECLINED = 'DECLINED';
export const ORDER_CAPTURE_PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED';
export const ORDER_CAPTURE_PENDING = 'PENDING';
export const ORDER_CAPTURE_REFUNDED = 'REFUNDED';

export const ORDER_AUTHORIZATION_CREATED = 'CREATED';
export const ORDER_AUTHORIZATION_CAPTURED = 'CAPTURED';
export const ORDER_AUTHORIZATION_DENIED = 'DENIED';
export const ORDER_AUTHORIZATION_EXPIRED = 'EXPIRED';
export const ORDER_AUTHORIZATION_PARTIALLY_CAPTURED = 'PARTIALLY_CAPTURED';
export const ORDER_AUTHORIZATION_VOIDED = 'VOIDED';
export const ORDER_AUTHORIZATION_PENDING = 'PENDING';

export const ORDER_REFUND_CANCELLED = 'CANCELLED';
export const ORDER_REFUND_PENDING = 'PENDING';
export const ORDER_REFUND_COMPLETED = 'COMPLETED';

export default {
    ORDER_CREATED,
    ORDER_SAVED,
    ORDER_APPROVED,
    ORDER_VOIDED,
    ORDER_COMPLETED,
    ORDER_PAYER_ACTION_REQUIRED,

    ORDER_CAPTURE_COMPLETED,
    ORDER_CAPTURE_DECLINED,
    ORDER_CAPTURE_PARTIALLY_REFUNDED,
    ORDER_CAPTURE_PENDING,
    ORDER_CAPTURE_REFUNDED,

    ORDER_AUTHORIZATION_CREATED,
    ORDER_AUTHORIZATION_CAPTURED,
    ORDER_AUTHORIZATION_DENIED,
    ORDER_AUTHORIZATION_EXPIRED,
    ORDER_AUTHORIZATION_PARTIALLY_CAPTURED,
    ORDER_AUTHORIZATION_VOIDED,
    ORDER_AUTHORIZATION_PENDING,

    ORDER_REFUND_CANCELLED,
    ORDER_REFUND_PENDING,
    ORDER_REFUND_COMPLETED,
};
